import { render, staticRenderFns } from "./ConfigAndSelectAddition.vue?vue&type=template&id=2208c710"
import script from "./ConfigAndSelectAddition.vue?vue&type=script&lang=js"
export * from "./ConfigAndSelectAddition.vue?vue&type=script&lang=js"
import style0 from "./ConfigAndSelectAddition.vue?vue&type=style&index=0&id=2208c710&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports